import { groupBy } from 'lodash';

import {
  useTagsDeleteByIds,
  useNotesDeleteByIds,
  useBlocksDeleteByIds,
  useUserSourceDeleteByIds,
  useInstructionsDeleteByIds,
} from '@/hooks/rxdb-models';

import type { MutationOptions } from '@/hooks/rxdb-base';
import type { DocumentWithType } from '@/constants/types';

export const useSmartDelete = () => {
  const { mutate: deleteBlocks, isLoading: areBlocksDeleting } = useBlocksDeleteByIds();
  const { mutate: deleteNotes, isLoading: areNotesDeleting } = useNotesDeleteByIds();
  const { mutate: deleteTags, isLoading: areTagsDeleting } = useTagsDeleteByIds();
  const { mutate: deleteUserSources, isLoading: areUserSourcesDeleting } = useUserSourceDeleteByIds();
  const { mutate: deleteInstructions, isLoading: areInstructionsDeleting } = useInstructionsDeleteByIds();

  const deleteDocs = (documents: DocumentWithType[], mutationOptions?: MutationOptions) => {
    const dataGroups = groupBy(documents, (item) => item.variant || item.type);
    const dataKeys: string[] = Object.keys(dataGroups);
    const promises: any[] = [];

    dataKeys.forEach((key) => {
      const ids = dataGroups[key].map((el) => el.id);
      switch (key) {
        case 'blocks':
          promises.push(deleteBlocks(ids, mutationOptions));
          break;
        case 'notes':
        case 'templates':
          promises.push(deleteNotes(ids, mutationOptions));
          break;
        case 'tags':
          promises.push(deleteTags(ids, mutationOptions));
          break;
        case 'userSources':
          promises.push(deleteUserSources(ids, mutationOptions));
          break;
        case 'instructions':
          promises.push(deleteInstructions(ids, mutationOptions));
          break;
      }
    });

    return Promise.all(promises);
  };

  return {
    delete: deleteDocs,
    isLoading: areBlocksDeleting || areNotesDeleting || areTagsDeleting || areUserSourcesDeleting || areInstructionsDeleting,
  };
};
